import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

const TabGallery = ({
    element,
    isActive,
    buttonRef,
    blueTagActive = false,
    ...rest
}) => {

    const activeTabStyle = blueTagActive ? "styles.blueActiveTab" : "styles.active";
    return (
        <button
            ref={buttonRef}
            styleName={`styles.tabButton ${isActive ? activeTabStyle : ""}`}
            {...rest}>
            {element}
        </button>
    );
};
TabGallery.propTypes = {
    element: PropTypes.element,
    isActive: PropTypes.bool,
    buttonRef: PropTypes.object,
    blueTagActive: PropTypes.bool
};
export default TabGallery;
